let allVariants = document.querySelectorAll('variant-selection .options-selection__option-value input');
let variantId;

function currentVariantId() {
  let activeVariant = document.querySelector('.product-form .options-selection__option-header .options-selection__option-name span').innerHTML.trim();

  allVariants.forEach(variant => {
    let value = variant.getAttribute('value').trim();

    if(value === activeVariant) {
      variantId = variant.getAttribute('data-variant-id').trim();
    }
  })
}

function triggerNotify(){
// let variant_id = +window.location.href.split('variant=')[1].trim();
currentVariantId();

  let variantsById = BISPopover._variantsById;
  BISPopover.variants.length = 0;

  for (const [key, value] of Object.entries(variantsById)) {
    if(`${value.id}` === variantId) {
      BISPopover.variants.push(value);
    }
  }

  BISPopover.createUI();
  BISPopover.toggle();
}